import React from "react";
import styles from "./HeroBanner.module.scss";

import clsx from "clsx";
import {
  ResponsiveSanityImage,
  ResponsiveSanityImageProps
} from "../ResponsiveSanityImage/ResponsiveSanityImage";
import { SectionContainer } from "../SectionContainer/SectionContainer";
import { ReactElement } from "react";

export interface HeroBannerProp {
  className?: string;
  overlayClassName?: string;
  size?: "normal" | "compact";
  background?: ResponsiveSanityImageProps["image"];
  backgroundImageComponent?: ReactElement;
  backgroundAlt?: string;
  loading?: React.ImgHTMLAttributes<HTMLImageElement>["loading"];
  overlay?: "right" | "left";
}

interface HeroBannerPanelProps {
  size?: "normal" | "large";
}

export const HeroBannerLeftPanel: React.FC<
  React.PropsWithChildren<HeroBannerPanelProps>
> = ({ children, size = "normal" }) => {
  return (
    <div
      className={clsx(styles.leftPanel, {
        [styles.largeLeftPanel]: size == "large"
      })}
    >
      {children}
    </div>
  );
};

export const HeroBannerRightPanel: React.FC<
  React.PropsWithChildren<HeroBannerPanelProps>
> = ({ children, size = "normal" }) => {
  return (
    <div
      className={clsx(styles.rightPanel, {
        [styles.largeRightPanel]: size == "large"
      })}
    >
      {children}
    </div>
  );
};

export const HeroBannerCenterPanel: React.FC<
  React.PropsWithChildren<HeroBannerPanelProps>
> = ({ children, size = "normal" }) => {
  return (
    <div
      className={clsx(styles.centerPanel, {
        [styles.largeCenterPanel]: size == "large"
      })}
    >
      {children}
    </div>
  );
};

export const HeroBannerTitle: React.FC<React.PropsWithChildren<unknown>> = (
  props
) => {
  return <h1 className={styles.title}>{props.children}</h1>;
};

export const HeroBannerContent: React.FC<React.PropsWithChildren<unknown>> = (
  props
) => {
  return <h2 className={styles.content}>{props.children}</h2>;
};

export const HeroBannerAction: React.FC<React.PropsWithChildren<unknown>> = (
  props
) => {
  return <div className={styles.actionContainer}>{props.children}</div>;
};

export const HeroBanner: React.FC<React.PropsWithChildren<HeroBannerProp>> = (
  props
) => {
  return (
    <div
      className={clsx(styles.heroBanner, props.className, {
        [styles.overlayLeft]: props.overlay == "left",
        [styles.overlayRight]: props.overlay == "right",
        [styles.sizeCompact]: props.size == "compact"
      })}
      data-content-name="hero"
    >
      <div className={styles.backgroundImageContainer}>
        {props.backgroundImageComponent ? (
          <React.Fragment>{props.backgroundImageComponent}</React.Fragment>
        ) : props.background ? (
          <ResponsiveSanityImage
            image={props.background}
            className={styles.heroImage}
            defaultWidth={1024}
            defaultHeight={400}
            alt={props.backgroundAlt}
            loading={props.loading || undefined}
          />
        ) : null}
      </div>
      <SectionContainer
        className={clsx(styles.overlay, props.overlayClassName)}
      >
        {props.children}
      </SectionContainer>
    </div>
  );
};
